import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogTitle, DialogTrigger } from "src/components/ui/dialog";
import { cva } from "class-variance-authority";
import { X } from "lucide-react";
import { cn } from "src/lib/utils";
import { Suspense } from "react";
import Loader from "./Loader";

const modalVariants = cva("tw-z-50 tw-flex tw-max-h-[80vh] tw-flex-col !tw-p-0", {
	variants: {
		size: {
			normal: "!tw-max-w-3xl",
			lg: "!tw-max-w-5xl",
			xl: "!tw-max-w-7xl",
			sm: "!tw-max-w-xl",
		},
	},
});

const DialogHeader = ({ className, ...props }) => (
	<div className={cn("tw-flex tw-flex-col tw-space-y-1.5 tw-text-center sm:tw-text-left", className)} {...props} />
);

export const CustomModal = ({ title, description, children, footer, className, size = "sm", ...rest }) => {
	if (rest["open"]) {
		const { open, onOpenChange } = rest;

		return (
			<Dialog open={open} onOpenChange={onOpenChange}>
				<DialogContent className={modalVariants({ size, className })}>
					<DialogHeader className="tw-sticky tw-top-0 tw-z-10 tw-h-fit tw-bg-background">
						<div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-4 tw-border-b tw-border-b-input md:tw-px-6 lg:tw-px-8">
							<div className="tw-w-full">
								<DialogTitle className="tw-max-w-[80%] tw-truncate tw-text-nowrap tw-text-left tw-text-lg tw-font-semibold tw-text-gray-700">
									{title}
								</DialogTitle>
								<DialogDescription className="tw-text-left">{description}</DialogDescription>
							</div>

							<DialogClose
								type="button"
								id="modal-close-button"
								className="!tw-m-0 tw-aspect-square tw-w-fit tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-1.5 hover:tw-bg-accent"
							>
								<X className="tw-size-4 tw-text-black" />
							</DialogClose>
						</div>
					</DialogHeader>
					<div className="tw-flex-1 tw-px-4 tw-pb-6 md:tw-px-6 lg:tw-px-8">
						<Suspense fallback={<Loader />}>{children}</Suspense>
					</div>
					{footer && <DialogFooter className="sm:tw-justify-start">{footer}</DialogFooter>}
				</DialogContent>
			</Dialog>
		);
	}

	const { trigger } = rest;
	return (
		<Dialog>
			<DialogTrigger asChild>{trigger}</DialogTrigger>
			<DialogContent className={modalVariants({ size, className })}>
				<DialogHeader className="tw-sticky tw-top-0 tw-z-10 tw-h-fit tw-bg-background">
					<div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-4 tw-border-b tw-border-b-input md:tw-px-6 lg:tw-px-8">
						<div className="tw-w-full">
							<DialogTitle className="tw-max-w-[80%] tw-truncate tw-text-nowrap tw-text-left tw-text-lg tw-font-semibold tw-text-gray-700">
								{title}
							</DialogTitle>
							<DialogDescription className="tw-text-left">{description}</DialogDescription>
						</div>

						<DialogClose
							type="button"
							id="modal-close-button"
							className="!tw-m-0 tw-aspect-square tw-w-fit tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-1.5 hover:tw-bg-accent"
						>
							<X className="tw-size-4 tw-text-black" />
						</DialogClose>
					</div>
				</DialogHeader>
				<div className="tw-flex-1 tw-px-4 tw-pb-10 md:tw-px-6 lg:tw-px-8">
					<Suspense fallback={<Loader />}>{children}</Suspense>
				</div>
				{footer && <DialogFooter className="sm:tw-justify-start">{footer}</DialogFooter>}
			</DialogContent>
		</Dialog>
	);
};
export default CustomModal;
